import type { ReactNode } from 'react';

interface StepContainerProps {
  children: ReactNode;
  animationKey: number;
}

export const StepContainer = ({ children, animationKey }: StepContainerProps) => (
  <div className="relative overflow-hidden rounded-2xl border bg-card/80 p-4 pb-4 shadow-sm backdrop-blur-sm sm:p-6">
    <div className="pointer-events-none absolute -right-20 -top-20 h-48 w-48 rounded-full bg-primary/10 blur-3xl" />
    <div className="pointer-events-none absolute -bottom-24 -left-24 h-56 w-56 rounded-full bg-emerald-400/10 blur-3xl" />
    <div
      key={animationKey}
      className="min-h-[520px] sm:min-h-[620px] animate-in fade-in slide-in-from-right-4 duration-300"
    >
      {children}
    </div>
  </div>
);
